import { fork, takeEvery } from "redux-saga/effects";

import WizardConstants from "modules/wizard/constants";
import WizardSagas from "modules/wizard/sagas";

function* watchCreateAds() {
  yield takeEvery(WizardConstants.CREATE_ADS, WizardSagas.CreateAds);
}

export default [fork(watchCreateAds)];
